/**
 * h5 与APP 交互接口
 */

import { SetAppLogin } from '@/api/app';
import { setLocalStorage, getLocalStorage } from '@/utils/local-storage';
import { Toast } from 'vant';
import Bus from "@/eventBus/index.js";

//判断平台类型
let ua = window.navigator.userAgent;
export const isIPhone = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

/**
 * 判断登录状态
 */
export function getLoginStatus() {
  
    if (isIPhone) {
        window.webkit.messageHandlers.appIsLogin.postMessage('appIsLogin');
    } else {
       window.android.appIsLogin();
    }
}


/*
*判断是否登录
*/
export function liveHasLogin() {
    // let { Authorization } = getLocalStorage('Authorization')
    // if (Authorization) {
    //     success()
    // } else {
    //     failed()
    // }
    return new Promise((res, rej) => {
        let { Authorization } = getLocalStorage('Authorization')
        if (Authorization) {
            res(Authorization)
        } else {
            rej('用户未登录app')
        }

    })
}

/**
 *打开登录界面
 */
export function opneLoginPane() {
    if (isIPhone) {
        window.webkit.messageHandlers.appNeedLogin.postMessage('appNeedLogin');
    } else {
        window.android.appNeedLogin();
    }
}
/**
 *返回用户信息
 */
export function getUserInfo() {
    if (isIPhone) {
        window.webkit.messageHandlers.getAppUserInfo.postMessage('getAppUserInfo');
    } else {
        return window.android.getAppUserInfo();
    }
}
/**
 *返回当前经纬度
 */
export function getLocation() {
    if (isIPhone) {
        window.webkit.messageHandlers.getLocation.postMessage('getLocation');
        const { iosloca } = getLocalStorage('iosloca');
        return iosloca;
    } else {
        return window.android.getLocation();
    }
}
/**
 *显示或隐藏nav
 */
export function setNavStatus(status) {
    if (isIPhone) {
        window.webkit.messageHandlers.showTitle.postMessage(status);
    } else {
        window.android.showTitle(status);
    }
}
export function setUser(data) {
    let user = JSON.parse(data);
    let userId = user.data.userId
    let parm;
    if (user.status == 200) {
        parm = {
            nickName: user.data.userNick ?
                user.data.userNick : user.data.userName ?
                    user.data.userName : '',
            avatar: user.data.userHeadPath ?
                user.data.userHeadPath : user.data.iconUrl ?
                    user.data.iconUrl : '',
            appUserid: user.data.userId,
            mobile: user.data.userPhone
        };
        Bus.$emit('update:userInfo', data)
        // SetAppLogin(parm)
        //     .then(res => {
        //         let userInfo = { ...res.data.data.userInfo, userId };
                
        //         Bus.$emit('update:userInfo', userInfo)
        //         Bus.$emit('initTIM')          
        //         setLocalStorage({
        //             Authorization: res.data.data.token,
        //             avatar: userInfo.avatarUrl ? userInfo.avatarUrl : userInfo.avatar,
        //             nickName: userInfo.nickName,
        //             userId
        //         });

        //     })
        //     .catch(error => {
        //       console.log('错误','bus');
        //         Toast.fail(error.data.errmsg);
        //     });
    }
}
//调取微信兑换
export function getWxPay(data) {
    let parm = JSON.stringify(data);
    if (isIPhone) {
        window.webkit.messageHandlers.openWChatPay.postMessage(parm);
    } else {
        return window.android.openWChatPay(parm);
    }
}
//调取支付宝兑换
export function getAliPay(data) {
    let parm = JSON.stringify(data);
    if (isIPhone) {
        window.webkit.messageHandlers.openALiPay.postMessage(parm);
    } else {
        return window.android.openALiPay(parm);
    }
}
//安卓获取授权
export function getAuth() {
    if (isIPhone) {
        //苹果无需授权
    } else {
        if (window.android.checkReadFilePermission()) { } else {
            window.android.getReadFilePermission();
        }
    }
}